// AuthService.js
export const isLoggedIn = () => {
  return localStorage.getItem("token") !== null;
};

export const clearSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user_name");
  localStorage.removeItem("user_image");
  localStorage.removeItem("user_role");
  localStorage.removeItem("account_id");
  localStorage.removeItem("user_email");
};

export const login = (token, extras = {}) => {
  localStorage.setItem("token", token);
  if (extras.role != null) {
    localStorage.setItem("user_role", extras.role);
  }
  if (extras.name != null) {
    localStorage.setItem("user_name", extras.name);
  }
  if (extras.image != null) {
    localStorage.setItem("user_image", extras.image);
  }
  if (extras.accountId != null) {
    localStorage.setItem("account_id", String(extras.accountId));
  }
  if (extras.email != null) {
    localStorage.setItem("user_email", extras.email);
  }
};

export const logout = () => {
  clearSession();
};
